import { render, staticRenderFns } from "./AppShare.vue?vue&type=template&id=4bb8d04c&scoped=true"
import script from "./AppShare.vue?vue&type=script&lang=js"
export * from "./AppShare.vue?vue&type=script&lang=js"
import style0 from "./AppShare.vue?vue&type=style&index=0&id=4bb8d04c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb8d04c",
  null
  
)

export default component.exports